import { Link } from "react-router-dom";
import { useReveal } from "@/lib/useReveal";

const PACKAGES = [
    {
        index: "01",
        name: "Экспертная поддержка",
        applyHref: "/apply/support",
        tagline: "Регулярное сопровождение вашей ИТ-разработки",
        forWhom:
            "Для тех, у кого команда работает, процессы в целом настроены, но иногда что-то буксует, а взгляд изнутри уже замылен. Вы хотите, чтобы опытный эксперт регулярно смотрел на систему со стороны, помогал видеть проблемы раньше, чем они станут критичными, и давал рекомендации по улучшениям.",
        whatIDo: [
            "Регулярные 1:1 сессии с собственником",
            "Разбор операционных решений и рисков",
            "Помогаю задавать правильные вопросы команде",
            "Подсвечиваю слепые зоны в процессах",
        ],
        whatYouGet: [
            "Ясную картину состояния разработки",
            "Уверенность в управленческих решениях",
            "Снятие тревоги «где-то не так»",
            "Постепенное усиление операционки",
        ],
        clientResp: [
            "Регулярно выделять время на встречи",
            "Открыто говорить о реальной ситуации",
            "Внедрять решения внутри команды",
        ],
        format: "От 4 недель · 1–2 встречи в неделю · Онлайн",
        accent: false,
    },
    {
        index: "02",
        name: "Вернуть контроль",
        applyHref: "/apply/control",
        tagline: "Глубокая диагностика и перезапуск процессов разработки",
        forWhom:
            "Для компаний, где разработка стала «чёрным ящиком»: процессы рассыпаны, сроки летят, фокус потерян. Нужно вернуть управляемость.",
        whatIDo: [
            "Аудит процессов, людей, продукта и метрик",
            "Карта зон риска и точек ускорения",
            "Перенастройка процессов и зон ответственности",
            "Сопровождаю изменения на стороне команды",
        ],
        whatYouGet: [
            "Понятную операционную модель ИТ‑блока",
            "Прозрачные сроки и предсказуемость релизов",
            "Снятие зависимости от одного «носителя контекста».",
            "Управляемый рост без выгорания команды",
        ],
        clientResp: [
            "Открытый доступ к команде, метрикам, артефактам",
            "Готовность к управленческим решениям",
            "Поддержка изменений на уровне собственника",
        ],
        format: "8–12 недель · Гибрид · Включена Карта результата",
        accent: true,
    },
    {
        index: "03",
        name: "Запуск отдела разработки",
        applyHref: "/apply/launch",
        tagline:
            "Выстраивание собственной ИТ‑разработки для автоматизации бизнес‑процессов",
        forWhom:
            "Для собственников, которые запускают новый продукт или направление и хотят построить собственный ИТ‑блок — без потери темпа и денег.",
        whatIDo: [
            "Собираю операционную модель и команду",
            "Декомпозирую продукт в дорожную карту",
            "Беру на себя продакшн-управление",
            "Веду до стабильного релиза и передачи внутрь",
        ],
        whatYouGet: [
            "Рабочий отдел разработки, который умеет запускать",
            "Документированные процессы и роли",
            "Команду, которой можно доверять",
            "Прозрачную экономику ИТ‑блока",
        ],
        clientResp: [
            "Чёткое видение продукта и приоритетов",
            "Решения по бюджету и фокусу",
            "Доступ к рынку, клиентам, экспертизе",
        ],
        format: "От 12 недель · Интенсивный режим · Полное вовлечение",
        accent: false,
    },
];

const Section = ({ label, items, variant = "light" }) => {
    const labelClass =
        "text-[10px] tracking-[0.32em] uppercase font-semibold text-[#C46342] mb-3";
    const itemTextClass =
        variant === "dark"
            ? "text-sm leading-relaxed text-[#FAF9F6]/90"
            : "text-sm leading-relaxed text-[#1B2A41]/85";
    const bulletClass =
        variant === "dark"
            ? "mt-2 inline-block w-1.5 h-1.5 bg-[#FAF9F6] shrink-0"
            : "mt-2 inline-block w-1.5 h-1.5 bg-[#1B2A41] shrink-0";
    return (
        <div>
            <div className={labelClass}>{label}</div>
            <ul className="space-y-2.5">
                {items.map((it, i) => (
                    <li key={i} className={`flex gap-3 ${itemTextClass}`}>
                        <span className={bulletClass} />
                        <span>{it}</span>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export const Packages = () => {
    const ref = useReveal();
    return (
        <section
            id="packages"
            data-testid="packages-section"
            className="relative py-28 sm:py-40 bg-[#F4F1EA] border-t border-[#1B2A41]/15"
        >
            <div ref={ref} className="vnutri-reveal max-w-[1440px] mx-auto px-6 sm:px-10 lg:px-16">
                <div className="grid lg:grid-cols-12 gap-10 lg:gap-20 mb-20">
                    <div className="lg:col-span-7">
                        <div className="flex items-center gap-4 mb-6">
                            <span className="w-12 h-px bg-[#C46342]" />
                            <span className="text-[11px] tracking-[0.4em] uppercase font-semibold text-[#C46342]">
                                02 · Форматы работы
                            </span>
                        </div>
                        <h2
                            data-testid="packages-title"
                            className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl tracking-[-0.03em] text-[#1B2A41] font-extralight leading-[1.02]"
                        >
                            Три формата —{" "}
                            <span className="font-semibold">
                                под глубину вашей задачи
                            </span>
                        </h2>
                    </div>
                    <div className="lg:col-span-5 lg:pt-8">
                        <p className="text-lg sm:text-xl leading-[1.6] text-[#1B2A41]/80 font-light">
                            От регулярного экспертного сопровождения до запуска отдела
                            разработки с нуля. Если не очевидно, какой формат ваш — напишите,
                            я помогу выбрать.
                        </p>
                    </div>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-3 gap-px bg-[#1B2A41]/10 border border-[#1B2A41]/10">
                    {PACKAGES.map((pkg, i) => (
                        <article
                            key={i}
                            data-testid={`package-card-${i}`}
                            className={`relative flex flex-col p-8 lg:p-10 transition-colors ${
                                pkg.accent
                                    ? "bg-[#1B2A41] text-white"
                                    : "bg-white text-[#1B2A41] hover:bg-[#F4F1EA]"
                            }`}
                        >
                            {pkg.accent && (
                                <span className="absolute top-6 right-6 text-[10px] tracking-[0.32em] uppercase font-semibold text-[#C46342] bg-white/10 px-2 py-1">
                                    Часто выбирают
                                </span>
                            )}
                            <div
                                className={`flex items-baseline gap-3 ${
                                    pkg.accent ? "text-white/60" : "text-[#1B2A41]/40"
                                }`}
                            >
                                <span className="text-xs tracking-[0.32em] uppercase font-semibold">
                                    Формат {pkg.index}
                                </span>
                            </div>
                            <h3
                                className={`mt-4 text-2xl sm:text-3xl tracking-tight font-semibold leading-tight ${
                                    pkg.accent ? "text-white" : "text-[#1B2A41]"
                                }`}
                            >
                                {pkg.name}
                            </h3>
                            <p
                                className={`mt-3 text-sm leading-relaxed ${
                                    pkg.accent ? "text-white/70" : "text-[#1B2A41]/65"
                                }`}
                            >
                                {pkg.tagline}
                            </p>

                            <div
                                className={`mt-8 pt-8 border-t ${
                                    pkg.accent
                                        ? "border-white/15"
                                        : "border-[#1B2A41]/10"
                                } space-y-7 flex-1`}
                            >
                                <div>
                                    <div
                                        className={`text-[10px] tracking-[0.32em] uppercase font-semibold mb-3 ${
                                            pkg.accent
                                                ? "text-[#C46342]"
                                                : "text-[#C46342]"
                                        }`}
                                    >
                                        Для кого
                                    </div>
                                    <p
                                        className={`text-sm leading-relaxed ${
                                            pkg.accent
                                                ? "text-white/85"
                                                : "text-[#1B2A41]/85"
                                        }`}
                                    >
                                        {pkg.forWhom}
                                    </p>
                                </div>

                                <div>
                                    <Section
                                        label="Что я делаю"
                                        items={pkg.whatIDo}
                                        variant={pkg.accent ? "dark" : "light"}
                                    />
                                </div>
                                <div>
                                    <Section
                                        label="Что вы получаете"
                                        items={pkg.whatYouGet}
                                        variant={pkg.accent ? "dark" : "light"}
                                    />
                                </div>
                                <div>
                                    <Section
                                        label="Зона ответственности заказчика"
                                        items={pkg.clientResp}
                                        variant={pkg.accent ? "dark" : "light"}
                                    />
                                </div>
                            </div>

                            <div
                                className={`mt-8 pt-6 border-t flex items-center justify-between gap-4 ${
                                    pkg.accent
                                        ? "border-white/15"
                                        : "border-[#1B2A41]/10"
                                }`}
                            >
                                <div>
                                    <div
                                        className={`text-[10px] tracking-[0.32em] uppercase font-semibold mb-1 ${
                                            pkg.accent ? "text-white/60" : "text-[#1B2A41]/50"
                                        }`}
                                    >
                                        Формат
                                    </div>
                                    <div
                                        className={`text-sm font-medium ${
                                            pkg.accent ? "text-white" : "text-[#1B2A41]"
                                        }`}
                                    >
                                        {pkg.format}
                                    </div>
                                </div>
                                {pkg.applyHref ? (
                                    <Link
                                        data-testid={`package-cta-${i}`}
                                        to={pkg.applyHref}
                                        className={`shrink-0 w-11 h-11 flex items-center justify-center transition-colors ${
                                            pkg.accent
                                                ? "bg-[#C46342] text-white hover:bg-[#8f4631]"
                                                : "bg-[#1B2A41] text-white hover:bg-[#101B2B]"
                                        }`}
                                        aria-label={`Узнать про формат ${pkg.name}`}
                                    >
                                        <svg
                                            width="16"
                                            height="12"
                                            viewBox="0 0 18 12"
                                            fill="none"
                                        >
                                            <path
                                                d="M1 6H17M17 6L12 1M17 6L12 11"
                                                stroke="currentColor"
                                                strokeWidth="1.5"
                                            />
                                        </svg>
                                    </Link>
                                ) : (
                                    <a
                                        data-testid={`package-cta-${i}`}
                                        href="https://t.me/ekulakova1"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className={`shrink-0 w-11 h-11 flex items-center justify-center transition-colors ${
                                            pkg.accent
                                                ? "bg-[#C46342] text-white hover:bg-[#8f4631]"
                                                : "bg-[#1B2A41] text-white hover:bg-[#101B2B]"
                                        }`}
                                        aria-label={`Узнать про формат ${pkg.name}`}
                                    >
                                        <svg
                                            width="16"
                                            height="12"
                                            viewBox="0 0 18 12"
                                            fill="none"
                                        >
                                            <path
                                                d="M1 6H17M17 6L12 1M17 6L12 11"
                                                stroke="currentColor"
                                                strokeWidth="1.5"
                                            />
                                        </svg>
                                    </a>
                                )}
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
};
